export default {
    MANAGE_USERS: { key: 'manage_users', label: 'Manage Users'},
    MAP_EDITOR: { key: 'map_editor', label: 'Map Editor'},
    CONVOY_CONTROL: { key: 'convoy_control', label: 'Convoy Control'},
    EVENT_MANAGER: { key: 'event_manager', label: 'Event Manager'},
    REAL_OPS_OPERATOR: { key: 'real_ops_operator', label: 'Real Ops Operator'},
};